<div class="file-upload" @fadeInOnEnter [@scaleOut]="isUploading$ | async">
	<ng-content />
	<div @fadeOutOnLeave class="file-upload-status" *ngIf="isUploading$ | async">
		<ion-progress-bar @fadeInOnEnter [value]="uploadProgress$ | async" />
	</div>
</div>
